// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3e9cc3e9","845":"5db75f1a"}[chunkId] + ".chunk.js";
};